import {appFetch, AppFetchResponse} from "../utils/appFetch";
import {ManagerFormValuesProps} from "../components/shopManagers/NewShopManagerModal";
import {BlackoutDateProps} from "../types/BlackoutPeriod";

export const getTemplatePresets = async (domain: string): Promise<AppFetchResponse> => {
    return appFetch({
        endpoint: `template-presets`,
        method: 'GET',
        headers: {
            "Content-Type": "application/json",
        },
        domain,
    });
}